(function () {

    'use strict';
    var serviceId = 'repository.gateoperationinventory';
    angular
        .module('app.services')
        .factory(serviceId, gateoperationinventory);

    gateoperationinventory.$inject = ['common', 'repository.abstract', '$http'];

    function gateoperationinventory(common, abstractRepository, $http) {
        var config = common.config;

        function Ctor(mgr) {
            this.manager = mgr;
            this.getFilters = getFilters;
            this.getCarrierList = getCarrierList;
            this.getTruckersByName = getTruckersByName;
            this.getGateOperationInventoryList = getGateOperationInventoryList;
            this.getApplicationSettingValue = getApplicationSettingValue;
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        function getFilters()
        {
            var authData = common.localStorageService.get('authorizationData');
            var codeRole = authData ? authData.userRole : "";
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetGateOperationInventoryFilters?codeRole=' + codeRole);
        }

        function getCarrierList() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetCarrierList');
        }

        function getTruckersByName(name) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetTruckersByName?criteria=' + name);
        }

        function getGateOperationInventoryList(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'reportList/GetGateOperationInventoryList', model);
        }

        function getApplicationSettingValue(categoryName, settingName) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/getApplicationSettingValue?categoryName=' + categoryName + '&settingName='+ settingName);
        }
    }

})();
